export default "__VITE_ASSET__CFd7s0np__"